module.exports = __webpack_public_path__ + "static/media/careerometer.a332d9be.png";